<script setup lang="ts">
import { defineProps, provide, ref } from 'vue'
import { CollapsibleRoot, CollapsibleTrigger, CollapsibleContent } from 'radix-vue'

import ListOfSourcesTrigger from './ListOfSourcesTrigger.vue'
import ListOfSourcesContent from './ListOfSourcesContent.vue'

// Define props for the component
defineProps<{
  headline: string
  showLabel: string
  hideLabel: string
  value: { sources: Array<{ plain: string; html: string }> }
}>()

const isExpanded = ref(false)

provide('isExpanded', isExpanded)
provide('toggleDropdown', () => {
  isExpanded.value = !isExpanded.value
})
</script>

<template>
  <CollapsibleRoot v-model:open="isExpanded"
                   class="w-full mx-auto md:mx-0 border-t border-separator overflow-hidden gap-1">
    <CollapsibleTrigger as-child>
      <ListOfSourcesTrigger :headline="headline"
                            :show-label="showLabel"
                            :hide-label="hideLabel" />
    </CollapsibleTrigger>
    <CollapsibleContent class="overflow-hidden data-[state=open]:animate-slideDownCollapsible data-[state=closed]:animate-slideUpCollapsible">
      <ListOfSourcesContent :sources="value.sources" />
    </CollapsibleContent>
  </CollapsibleRoot>
</template>
